<template>
    <div class="qr_parent_box">
        <div class="qr_parent_top" style="">
            <!-- 名称 -->
            <img src="../assets/icon_fanhui_create.svg" width="30px" style="margin-left: 11px;" alt="">
            <div
                style="position: absolute;left: 50%;  transform: translate(-50%, 0%);font-weight: 500;font-size: 19px;">
                {{ t("three.pagetitle") }}</div>
        </div>
        <div class="qr_parente_center">
            <img src="../assets/scan_box_horizontal.png" width="250px" alt="">
            <div class="qr_parente_center_box">
                <img src="../assets/qr.svg" width="150px" alt="">
            </div>

        </div>
    </div>

</template>

<script setup>
import { useI18n } from "vue-i18n";

const { t } = useI18n();

</script>

<style scoped>
.qr_parent_box {
    width: 300px;
    height: 666px;
    position: relative;
    background-image: url('../assets/bg.webp');
    background-size: cover;
    /* 拉伸填满容器 */
    background-position: center;
    /* 居中显示 */
    background-repeat: no-repeat;
}

.qr_parent_top {
    display: flex;
    margin-top: 69px;
}

.qr_parente_center {
    position: relative;
    margin-top: 50px;
}

.qr_parente_center_box {
    position: absolute;
    background-color: white;
    padding: 12px;
    border-radius: 12px;
    top: 32px;
    right: 50%;
    transform: translateX(50%);
}
</style>